// Import icons

// Import global mixins for access control
import { useGlobalMixins } from '@martyrs/src/modules/core/views/mixins/mixins.js';

const { isModuleInstalled } = useGlobalMixins();

// User profile navigation configuration
export const navigationItems = [
  {
    category: '',
    visible: () => true,
    items: [
      {
        title: 'auth.nav.dashboard',
        icon: 'home',
        route: (auth, route) => `/users/${route.params._id}/dashboard`,
        visible: (auth, route) => auth.user && auth.user._id === route.params._id // Only owner
      },
      {
        title: 'auth.nav.notifications',
        icon: 'notifications',
        route: (auth, route) => `/users/${route.params._id}/notifications`,
        visible: (auth, route) => auth.user && auth.user._id === route.params._id
      },
      {
        title: 'auth.nav.settings',
        icon: 'settings',
        route: (auth, route) => `/users/${route.params._id}/edit/profile`,
        visible: (auth, route) => auth.user && auth.user._id === route.params._id
      },
    ]
  },
  {
    category: 'auth.nav.sections.profile',
    visible: () => true,
    items: [
      {
        title: 'auth.nav.profile',
        icon: 'profile',
        route: (auth, route) => `/users/${route.params._id}`,
        visible: () => true // Public access
      },
      {
        title: 'auth.nav.events',
        icon: 'events',
        route: (auth, route) => `/users/${route.params._id}/events`,
        visible: () => isModuleInstalled('events')
      },
      {
        title: 'auth.nav.groups',
        icon: 'groups',
        route: (auth, route) => `/users/${route.params._id}/organizations`,
        visible: () => isModuleInstalled('organizations')
      },
      {
        title: 'auth.nav.posts',
        icon: 'community',
        route: (auth, route) => `/users/${route.params._id}/blogposts`,
        visible: () => isModuleInstalled('community')
      },
    ]
  },
  {
    category: 'auth.nav.sections.orders',
    visible: (auth, route) => isModuleInstalled('orders') && (
      auth.user && (
        auth.user._id === route.params._id ||
        (auth.access.roles &&
          (auth.access.roles.includes('ROLE_MODERATOR') ||
            auth.access.roles.includes('ROLE_ADMIN'))
        )
      )
    ),
    items: [
      {
        title: 'auth.nav.orders',
        icon: 'orders',
        route: (auth, route) => `/users/${route.params._id}/orders`
      },
    ]
  },
];

export default navigationItems;
